// @module eComm.InsertsExtension.InsertsExtension
define('eComm.InsertsExtension.InsertsExtension.View'
,	[
		'SC.Configuration',
		'SuiteDynamics.Inserts.Collection',
		'ecomm_insertsextension_insertsextension.tpl',
		'Backbone',
		'jQuery',
		'underscore',
		'Utils'
	]
,	function (
		Configuration,
		InsertsCollection,
		ecomm_insertsextension_insertsextension_tpl,
		Backbone,
		jQuery,
		_,
		Utils
	)
{
	'use strict';

	var insertView;

	// @class eComm.InsertsExtension.InsertsExtension.View @extends Backbone.View
	return Backbone.View.extend({

		template: ecomm_insertsextension_insertsextension_tpl,

		events: {
			'change [data-action="change-insert-options"]': 'changeInsert',
			'change input[name="insertquantity"]': 'changeQuantity'
		},

		initialize: function (options) {
			var self = this;
			insertView = this;
			this.container = options.container;
			this.pdp = options.pdp;
			this.cart = options.container.getComponent('Cart');
			this.layout = options.container.getComponent('Layout');
			this.isB2B = options.isB2B;
			this.environment = this.container.getComponent('Environment');
			this.insertConfig = Configuration.get('insertsExtension.insertsConfiguration', []);
			this.selectedInsert = null;
			this.showRequired = false;

			if (this.pdp) {
				this.loadInserts();
			}

			var cartEventsAttached = false;
			this.on('afterViewRender', function (){
				if (self.pdp) {
					self.pdp.setOption('custcol_ano_inserts_internalid', jQuery('select[name="inserts"]', self.$el).val());
					self.pdp.setOption('custcol_ano_inserts_quantity', jQuery('input[name="insertquantity"]', self.$el).val());

					if (self.inserts.length && !cartEventsAttached) {
						jQuery(document).ready(function () {
							jQuery(document).on('click', '[data-type="add-to-cart"]', _.bind(self.validateInsertOption, self));
							cartEventsAttached = true;
						});
					}
				}
			});

			if (this.inserts.length && this.isB2B) {
				var insertIds = _.pluck(this.inserts, 'insertid');
				this.getInsertItems(insertIds).done(function(insertItems) {
					self.insertPrices = {};
					_.each(insertItems, function(insertItem) {
						if (insertItem.matrixchilditems_detail && insertItem.matrixchilditems_detail.length) {
							var firstChild = insertItem.matrixchilditems_detail[0];
							self.insertPrices[insertItem.internalid] = firstChild.onlinecustomerprice_detail.onlinecustomerprice;
						} else {
							self.insertPrices[insertItem.internalid] = insertItem.onlinecustomerprice_detail.onlinecustomerprice;
						}
					});
					// self.setInsertPrices();
				});
			}

			this.cart.on('afterAddLine', _.bind(this.cartValidation, this));
			this.cart.on('afterUpdateLine', _.bind(this.cartValidation, this));
		},

		cartValidation: function() {
			if (this.inserts.length) {
				this.validateInsertOption();
				this.makeInsertSelectionMandatory();
			}
		},

		loadInserts: function() {
			var item = this.pdp.getItemInfo().item;
			var inserts = _.where(this.insertConfig, {
				customersegmentation: this.isB2B ? 'B2B' : 'B2C',
				shoetype: item.class
			});
			var session = this.environment.getSession();
			var currencySymbol = session.currency.symbol;
			var self = this;

			this.inserts = _.map(inserts || [], function(insert) {
				var insertName;

				if (!self.isB2B) {
					if (insert.insertid === '-999') {
						insertName = insert.insertname;
					} else if (parseFloat(insert.addOnPrice) === 0) {
						insertName = insert.insertname + ' - ' + Utils.translate('Free');
					} else {
						var quantity = parseFloat(insert.defaultquantity) || 1;
						insertName = insert.insertname + ' - ' + currencySymbol + insert.addOnPrice + (quantity > 1 ? ' Each' : '');
					}
				} else {
					insertName = insert.insertname;
				}

				return _.extend({}, insert, {
					insertname: insertName,
					selected: false
				});
			});

			var noInsert = _.find(this.inserts, { insertid: '-999' });
			if (noInsert) {
				this.inserts = [noInsert].concat(_.without(this.inserts, noInsert));
			}

			if (this.inserts.length) {
				this.makeInsertSelectionMandatory();
			}
		},

		getInsertItems: function(insertIds) {
			var deferred = jQuery.Deferred();
			var insertItems = {};
			var itemCollection = new InsertsCollection();
			var filteredInsertIds = insertIds.filter(function(id) {
				return id;
			});

			if (filteredInsertIds.length > 0) {
				itemCollection.fetch({
					data: {
						id: filteredInsertIds.join(',')
					}
				}).done(function(resp) {
					var items = resp.items;
					_.each(items, function(item) {
						insertItems[item.internalid] = item;
					});
					deferred.resolve(insertItems);
				}).fail(function() {
					deferred.reject('Failed to fetch insert items');
				});
			} else {
				deferred.resolve(insertItems);
			}

			return deferred;
		},


		setInsertPrices: function() {
			for (var i = 0; i < this.inserts.length; i++) {
				var insertid = parseInt(this.inserts[i].insertid);
				if (this.insertPrices[insertid]) {
					var insertPrice = this.insertPrices[insertid];
					if (parseFloat(insertPrice) === 0) {
						this.inserts[i].insertname = this.inserts[i].insertname  + ' - ' + Utils.translate('Free');
					} else {
						var quantity = parseFloat(this.inserts[i].defaultquantity) || 1;
						var session = this.environment.getSession();
						var currencySymbol = session.currency.symbol;
						this.inserts[i].insertname = this.inserts[i].insertname + ' - ' + currencySymbol + insertPrice + (quantity > 1 ? ' Each' : '');
					}
				}
			}
			this.render();
		},

		makeInsertSelectionMandatory: function() {
			var application = this.layout.application;
			var appLayout = application && application.layout;
			var currentView = appLayout && (appLayout.modalCurrentView || appLayout.currentView || null);
			var model = currentView && currentView.model;
			var options = model && model.get('options');
			var insertIdOption = options && options.findWhere({ cartOptionId: 'custcol_ano_inserts_internalid' });
			if (insertIdOption) {
				insertIdOption.set('isMandatory', true);
			}
		},

		validateInsertOption: function() {
			this.showRequired = !this.selectedInsert;
			this.render();
		},

		changeInsert: function (e){
			var item = this.pdp.getItemInfo().item;
			this.selectedInsert = _.find(this.inserts, {
				customersegmentation: this.isB2B ? 'B2B' :'B2C',
				shoetype: item.class,
				insertid: jQuery('select[name="inserts"] option:selected').val()
			});

			for (var i = 0; i < this.inserts.length; i++) {
				this.inserts[i].selected = this.selectedInsert && this.inserts[i].insertid === this.selectedInsert.insertid;
			}

			this.pdp.setOption('custcol_ano_inserts_internalid', jQuery('select[name="inserts"] option:selected').val() || '');
			this.pdp.setOption('custcol_ano_inserts_quantity', jQuery('input[name="insertquantity"]', self.$el).val() || 0);

			this.validateInsertOption();

			if (!this.selectedInsert) {
				this.pdp.setOption('custcol_ano_inserts_internalid', null);
			}
		},

		changeQuantity: function (e){
			this.pdp.setOption('custcol_ano_inserts_quantity', jQuery('input[name="insertquantity"]', self.$el).val() || 0);
		},

		destroy: function() {
			jQuery(document).off('click', '[data-type="add-to-cart"]', _.bind(this.validateInsertOption, this));
			this.cart.off('afterAddLine', _.bind(this.cartValidation, this))
			this.cart.off('afterUpdateLine', _.bind(this.cartValidation, this));
			this._destroy();
		},

		//@method getContext @return eComm.InsertsExtension.InsertsExtension.View.Context
		getContext: function getContext() {
			//@class eComm.InsertsExtension.InsertsExtension.View.Context
			return {
				showInserts: this.inserts && this.inserts.length > 0,
				label: _('Inserts').translate(),
				showLabel: true,
				inserts: this.inserts,
				showSelect: !this.selectedInsert,
				selectedInsert: this.selectedInsert,
				quantityDisabled: !this.isB2B,
				showRequired: this.showRequired
			}
		}
	});
});
